/* eslint-disable import/prefer-default-export */
export async function activateWaitingServiceWorkerAndReload(): Promise<void> {
  if (!('serviceWorker' in navigator)) {
    window.location.reload();
    return;
  }

  const registration = await navigator.serviceWorker.ready;
  const { waiting } = registration;

  if (!waiting) {
    window.location.reload();
    return;
  }

  const reloadOnControllerChange = () => {
    navigator.serviceWorker.removeEventListener(
      'controllerchange',
      reloadOnControllerChange,
    );
    window.location.reload();
  };

  navigator.serviceWorker.addEventListener(
    'controllerchange',
    reloadOnControllerChange,
  );

  waiting.postMessage({ type: 'SKIP_WAITING' });
}
